export default {
    getCompanies: { method: 'get', url: 'companies' },
    postCompanies: { method: 'post', url: 'companies' },
    putCompanies: { method: 'put', url: 'companies/{id}' },
    deleteCompanies: { method: 'delete', url: 'companies/{id}' },
}
